import React, { FC, MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./IconButton.module.css";

export type Variant = "primary" | "secondary" | "submit" | "cancel" | "text";

interface IconButtonProps {
    children: ReactNode;
    type?: "button" | "submit" | "reset";
    size?: "small" | "medium" | "large";
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    to?: string;
    href?: string;
    target?: "_blank" | "_self" | "_parent" | "_top";
}

const IconButton: FC<IconButtonProps> = ({
    children,
    type = "button",
    size = "medium",
    disabled = false,
    onClick,
    to,
    href,
    target = "_self",
}) => {
    const ariaLabel = typeof children === "string" ? children : undefined;

    if (to) {
        return (
            <Link
                to={to}
                className={`${styles.button} ${styles[size]} ${disabled ? styles.disabled : ""}`}
                aria-label={ariaLabel}
                aria-disabled={disabled}
            >
                {children}
            </Link>
        );
    }

    if (href) {
        return (
            <a
                href={href}
                target={target}
                className={`${styles.button} ${styles[size]} ${disabled ? styles.disabled : ""}`}
                aria-label={ariaLabel}
                aria-disabled={disabled}
                rel={target === "_blank" ? "noopener noreferrer" : undefined}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            className={`${styles.button} ${styles[size]} ${disabled ? styles.disabled : ""}`}
            disabled={disabled}
            aria-label={ariaLabel}
            aria-disabled={disabled}
        >
            {children}
        </button>
    );
};

export default IconButton;
